// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DsueFormClientFragment = { __typename?: 'ClientProfile', id: string, displayName: string, dsue?: { __typename?: 'DSUEPortability', id: string, amount: CurrencyUSD, eventDate: Time, notes?: string | null, documents?: Array<{ __typename?: 'Document', id: string }> | null } | null };

export type DsueFormQueryVariables = Types.Exact<{
  householdWhereInput: Types.HouseholdWhereInput;
}>;


export type DsueFormQuery = { __typename?: 'Query', households: { __typename?: 'HouseholdConnection', edges?: Array<{ __typename?: 'HouseholdEdge', node?: { __typename?: 'Household', id: string, possiblePrimaryClients: Array<(
          { __typename?: 'ClientProfile' }
          & DsueFormClientFragment
        )> } | null } | null> | null } };

export type CreateDsuePortabilityMutationVariables = Types.Exact<{
  input: Types.AugmentedCreateDsuePortabilityInput;
}>;


export type CreateDsuePortabilityMutation = { __typename?: 'Mutation', createDsuePortability: { __typename?: 'DSUEPortability', id: string } };

export type UpdateDsuePortabilityMutationVariables = Types.Exact<{
  input: Types.AugmentedUpdateDsuePortabilityInput;
}>;


export type UpdateDsuePortabilityMutation = { __typename?: 'Mutation', updateDsuePortability: { __typename?: 'DSUEPortability', id: string } };

export type DeleteDsuePortabilityMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DeleteDsuePortabilityMutation = { __typename?: 'Mutation', deleteDsuePortability: string };

export const Operations = {
  Query: {
    DSUEForm: 'DSUEForm' as const
  },
  Mutation: {
    CreateDSUEPortability: 'CreateDSUEPortability' as const,
    UpdateDSUEPortability: 'UpdateDSUEPortability' as const,
    DeleteDSUEPortability: 'DeleteDSUEPortability' as const
  },
  Fragment: {
    DSUEFormClient: 'DSUEFormClient' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const DsueFormClientFragmentDoc = gql`
    fragment DSUEFormClient on ClientProfile {
  id
  displayName
  dsue {
    id
    amount
    eventDate
    notes
    documents {
      id
    }
  }
}
    `;
export const DsueFormDocument = gql`
    query DSUEForm($householdWhereInput: HouseholdWhereInput!) {
  households(where: $householdWhereInput) {
    edges {
      node {
        id
        possiblePrimaryClients {
          ...DSUEFormClient
        }
      }
    }
  }
}
    ${DsueFormClientFragmentDoc}`;

/**
 * __useDsueFormQuery__
 *
 * To run a query within a React component, call `useDsueFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useDsueFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDsueFormQuery({
 *   variables: {
 *      householdWhereInput: // value for 'householdWhereInput'
 *   },
 * });
 */
export function useDsueFormQuery(baseOptions: Apollo.QueryHookOptions<DsueFormQuery, DsueFormQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DsueFormQuery, DsueFormQueryVariables>(DsueFormDocument, withFetchPolicyContext(options));
      }
export function useDsueFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DsueFormQuery, DsueFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DsueFormQuery, DsueFormQueryVariables>(DsueFormDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function useDsueFormSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DsueFormQuery, DsueFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DsueFormQuery, DsueFormQueryVariables>(DsueFormDocument, withFetchPolicyContext(options));
        }
export type DsueFormQueryHookResult = ReturnType<typeof useDsueFormQuery>;
export type DsueFormLazyQueryHookResult = ReturnType<typeof useDsueFormLazyQuery>;
export type DsueFormSuspenseQueryHookResult = ReturnType<typeof useDsueFormSuspenseQuery>;
export type DsueFormQueryResult = Apollo.QueryResult<DsueFormQuery, DsueFormQueryVariables>;
export const CreateDsuePortabilityDocument = gql`
    mutation CreateDSUEPortability($input: AugmentedCreateDSUEPortabilityInput!) {
  createDsuePortability(input: $input) {
    id
  }
}
    `;
export type CreateDsuePortabilityMutationFn = Apollo.MutationFunction<CreateDsuePortabilityMutation, CreateDsuePortabilityMutationVariables>;

/**
 * __useCreateDsuePortabilityMutation__
 *
 * To run a mutation, you first call `useCreateDsuePortabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDsuePortabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDsuePortabilityMutation, { data, loading, error }] = useCreateDsuePortabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDsuePortabilityMutation(baseOptions?: Apollo.MutationHookOptions<CreateDsuePortabilityMutation, CreateDsuePortabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDsuePortabilityMutation, CreateDsuePortabilityMutationVariables>(CreateDsuePortabilityDocument, options);
      }
export type CreateDsuePortabilityMutationHookResult = ReturnType<typeof useCreateDsuePortabilityMutation>;
export type CreateDsuePortabilityMutationResult = Apollo.MutationResult<CreateDsuePortabilityMutation>;
export type CreateDsuePortabilityMutationOptions = Apollo.BaseMutationOptions<CreateDsuePortabilityMutation, CreateDsuePortabilityMutationVariables>;
export const UpdateDsuePortabilityDocument = gql`
    mutation UpdateDSUEPortability($input: AugmentedUpdateDSUEPortabilityInput!) {
  updateDsuePortability(input: $input) {
    id
  }
}
    `;
export type UpdateDsuePortabilityMutationFn = Apollo.MutationFunction<UpdateDsuePortabilityMutation, UpdateDsuePortabilityMutationVariables>;

/**
 * __useUpdateDsuePortabilityMutation__
 *
 * To run a mutation, you first call `useUpdateDsuePortabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDsuePortabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDsuePortabilityMutation, { data, loading, error }] = useUpdateDsuePortabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDsuePortabilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDsuePortabilityMutation, UpdateDsuePortabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDsuePortabilityMutation, UpdateDsuePortabilityMutationVariables>(UpdateDsuePortabilityDocument, options);
      }
export type UpdateDsuePortabilityMutationHookResult = ReturnType<typeof useUpdateDsuePortabilityMutation>;
export type UpdateDsuePortabilityMutationResult = Apollo.MutationResult<UpdateDsuePortabilityMutation>;
export type UpdateDsuePortabilityMutationOptions = Apollo.BaseMutationOptions<UpdateDsuePortabilityMutation, UpdateDsuePortabilityMutationVariables>;
export const DeleteDsuePortabilityDocument = gql`
    mutation DeleteDSUEPortability($id: ID!) {
  deleteDsuePortability(id: $id)
}
    `;
export type DeleteDsuePortabilityMutationFn = Apollo.MutationFunction<DeleteDsuePortabilityMutation, DeleteDsuePortabilityMutationVariables>;

/**
 * __useDeleteDsuePortabilityMutation__
 *
 * To run a mutation, you first call `useDeleteDsuePortabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDsuePortabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDsuePortabilityMutation, { data, loading, error }] = useDeleteDsuePortabilityMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteDsuePortabilityMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDsuePortabilityMutation, DeleteDsuePortabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDsuePortabilityMutation, DeleteDsuePortabilityMutationVariables>(DeleteDsuePortabilityDocument, options);
      }
export type DeleteDsuePortabilityMutationHookResult = ReturnType<typeof useDeleteDsuePortabilityMutation>;
export type DeleteDsuePortabilityMutationResult = Apollo.MutationResult<DeleteDsuePortabilityMutation>;
export type DeleteDsuePortabilityMutationOptions = Apollo.BaseMutationOptions<DeleteDsuePortabilityMutation, DeleteDsuePortabilityMutationVariables>;